/**
 * @generated SignedSource<<f5cead5b2550ee9178066c428d802e5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemContact_todo$data = {
  readonly contact: {
    readonly email: string | null;
    readonly name: string | null;
    readonly phoneNumber: string | null;
  } | null;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly " $fragmentType": "TodoListItemContact_todo";
};
export type TodoListItemContact_todo$key = {
  readonly " $data"?: TodoListItemContact_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemContact_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemContact_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "a3972d91b47a5df655e4f2803493c098";

export default node;
